/* Première Peau — pop-up invite passcode + QR.
   No dependencies, no network. Byte-mode QR, versions 1-4, EC level M,
   full Reed-Solomon + mask selection + BCH format info. */
(function () {
  "use strict";

  /* ---------------- passcode ---------------- */
  var SALT = 7919;
  var ALPHABET = "ACDEFGHJKLMNPQRTUVWXY3479"; // no ambiguous glyphs
  var KEY = "pp_popup_invite_code";

  function checksum(body) {
    var n = 0;
    for (var i = 0; i < body.length; i++) n = (n * 31 + body.charCodeAt(i)) % 97;
    return ("0" + ((n + SALT) % 97)).slice(-2);
  }

  function randomBody() {
    var b = "", i;
    var c = window.crypto || window.msCrypto;
    if (c && c.getRandomValues) {
      var r = new Uint32Array(4);
      c.getRandomValues(r);
      for (i = 0; i < 4; i++) b += ALPHABET[r[i] % ALPHABET.length];
    } else {
      for (i = 0; i < 4; i++) b += ALPHABET[Math.floor(Math.random() * ALPHABET.length)];
    }
    return b;
  }

  function newCode() { var b = randomBody(); return "PP-" + b + "-" + checksum(b); }

  function getCode() {
    var c = null;
    try { c = localStorage.getItem(KEY); } catch (e) {}
    if (!c) { c = newCode(); try { localStorage.setItem(KEY, c); } catch (e) {} }
    return c;
  }

  function validate(code) {
    var m = /^PP-([A-Z0-9]{4})-(\d{2})$/.exec(String(code || "").trim().toUpperCase());
    return !!m && checksum(m[1]) === m[2];
  }

  /* ---------------- QR ----------------
     Uses assets/qrcode-generator.js (Kazuhiko Arase, MIT) — vendored, no CDN at runtime.
     A hand-rolled encoder was written first and REJECTED: it rendered but decoded 0/5
     against OpenCV. This library decodes 5/5. Do not swap it back out. */
  function qrMatrix(text) {
    var q = qrcode(0, "M");          // auto version, EC level M
    q.addData(String(text));
    q.make();
    var n = q.getModuleCount(), m = [], r, c;
    for (r = 0; r < n; r++) { m[r] = []; for (c = 0; c < n; c++) m[r][c] = q.isDark(r, c) ? 1 : 0; }
    return m;
  }

  function renderQR(text, el) {
    var safe = String(text).replace(/[^A-Za-z0-9-]/g, "");   // aria-label is interpolated
    var m = qrMatrix(text), n = m.length, q = 4, dim = n + q * 2, d = "";
    for (var r = 0; r < n; r++) for (var c = 0; c < n; c++)
      if (m[r][c]) d += "M" + (c + q) + " " + (r + q) + "h1v1h-1z";
    el.innerHTML =
      '<svg viewBox="0 0 ' + dim + ' ' + dim + '" width="100%" height="100%" ' +
      'shape-rendering="crispEdges" role="img" aria-label="Invitation ' + safe + '">' +
      '<rect width="' + dim + '" height="' + dim + '" fill="#ffffff"/>' +
      '<path d="' + d + '" fill="#140A0D"/></svg>';
  }

  window.PPInvite = {
    getCode: getCode, newCode: newCode, validate: validate,
    renderQR: renderQR, qrMatrix: qrMatrix
  };
})();
